<template>
  <div class="user_detail">
    <p class="detail_title">
      <span>用户</span>
      <span class="title">{{userData.name}}</span>
      <span>详情</span>
       <Button class="btn" type="primary" @click="handleClick"> 
         跟进记录
      </Button>
    </p>
    <div class="basic_info">
      <p class="table_caption">基本资料</p>
      <Row>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">ID：</span>
          <span class="info_txt">{{userData.id}}</span>
        </Col>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">手机号：</span>
          <span class="info_txt">{{userData.phone}}</span>
        </Col>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">平台昵称：</span>
          <span class="info_txt">{{userData.name}}</span>
        </Col>
        <Col :xs="24" :sm="12" :md="6" :lg="6">
          <span class="info_title">微信昵称：</span>
          <span class="info_txt">{{userData.nickname}}</span>
        </Col>
      </Row>
        <Row>
          <Col :xs="24" :sm="12" :md="6" :lg="6">
            <span class="info_title">公众号：</span>
            <span class="info_txt">{{userData.wxGzhId > 0 ? '已关注' : '未关注'}}</span>
          </Col>
          <Col :xs="24" :sm="12" :md="6" :lg="6">
            <span class="info_title">认证时间：</span>
            <span class="info_txt">{{userData.createTime}}</span>
          </Col>
      </Row>
    </div>
    <p class="table_caption">教师身份</p>
    <Table stripe border size="large" :columns="teacherHeader" :data="userData.teacherList">
      <template slot-scope="{row}" slot="schoolName">
        <div class="jump_color" @click="toSchoolDetail(row.schoolId)">{{row.schoolName}}</div>
      </template>
      <template slot-scope="{row}" slot="className">
        <div class="jump_color" @click="toClassDetail(row.classId)">{{row.classGrade + row.className}}</div>
      </template>
      <template slot-scope="{row}" slot="roleId">
        <span>{{row.roleId === 3 ? '班主任' : '老师'}}</span>
      </template>
    </Table>
    <p class="table_caption">家长身份</p>
    <Table stripe border size="large" :columns="parentHeader" :data="userData.parentList">
      <template slot-scope="{row}" slot="schoolName">
        <div class="jump_color" @click="toSchoolDetail(row.schoolId)">{{row.schoolName}}</div>
      </template>
      <template slot-scope="{row}" slot="className">
        <div class="jump_color" @click="toClassDetail(row.classId)">{{row.classGrade + row.className}}</div>
      </template>
      <template slot-scope="{row}" slot="studentName">
        <div class="jump_color" @click="toUserDetail(row.studentUserId)">{{row.studentName}}</div>
      </template>
    </Table>
  </div>
</template>
<script>
  import {dealDate} from '../common/common';
  import {_getUserDetail} from '../api/api';
  export default {
    data() {
      return {
        id: '',
        userData:{},
        teacherHeader:[
          {
            title: '称呼',
            key: 'rosterName'
          },
          {
            title: '学校',
            key: 'schoolName',
            slot: 'schoolName'
          },
          {
            title: '班级',
            key: 'className',
            slot: 'className'
          },
          {
            title: '身份',
            key: 'roleId',
            slot: 'roleId'
          }
        ],
        parentHeader:[
          {
            title: '学校',
            key: 'schoolName',
            slot: 'schoolName'
          },
          {
            title: '班级',
            key: 'className',
            slot: 'className'
          },
          {
            title: '学生',
            key: 'studentName',
            slot: 'studentName'
          },
          {
            title: '关系',
            key: 'kindred',
          }
        ]
      }
    },
    methods: {
//      获取用户列表
      getUserDetail() {
        const self = this;
        _getUserDetail(self.id).then(res => {
          if(res.code === 0){
            res.data.createTime = dealDate(res.data.createTime);
            self.userData = res.data;

          }
        })
      },
//      跳转到班级详情
      toClassDetail(classId){
        this.$router.push(`/klasses/detail?id=${classId}`)
      },
//      跳转到学校列表
      toSchoolDetail(schoolId){
        this.$router.push(`/schools?id=${schoolId}`);
      },
      toUserDetail(id) {
        this.id = id;
        this.getUserDetail();
      },
      handleClick(){
        console.log(this.userData.phone)
        this.$router.push({name:`Customer`,params:this.userData});
      }
    },
    created() {
      this.id = this.$route.query.id;
    },
    mounted() {
      this.getUserDetail();
    }
  };
</script>
<style>
.detail_title{
  position: relative;
}
.btn{
  position: absolute;
  left: 0;  
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UserDetail.vue